import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts, relacionamentos } from '../../settings';
import { DelayLink, SliderText } from '../../components';

import './ParaOMercado.scss';

class ParaOMercado extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Para o mercado - {texts.title}</title>
        </Helmet>

        <div className="para-o-mercado-home page-gradient page-gradient--yellow bg-gray" ref="para-o-mercado-home">
          <section className="para-o-mercado-home-area page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="page-header">
                      <DelayLink
                        to="/estrategias/nosso-ano"
                        className="button button--aylen button--white-to-yellow button--border-medium button--size-m button--round-l button--text-thick"
                      >
                        Voltar
                      </DelayLink>

                      <h1 className="page-header__title">
                        <span className="gri_text">
                          Para o mercado
                          <span className="gri_label">
                            GRI <b>103-1, 103-2, 103-3</b>
                          </span>
                        </span>
                        <small>
                          Clique nos temas <br className="br_desk" />
                          para saber mais
                        </small>
                      </h1>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="para-o-mercado-body">
            <div className="container container--large">
              <div className="row">
                <div className="col-6">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/agenda-recursos" className="card card--yellow with-image">
                      <div className="card__content card__content--full card1">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--large title-card1">
                            Publicação da  <br className="br_desk" />
                            Agenda ANBIMA <br className="br_desk" />
                            de Gestão <br className="br_desk" />
                            de Recursos
                          </h2>
                          <img src={images.para_o_mercado.grafico_gestao} className="grafico_gestao" />
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>

                <div className="col-3">
                  <Fade bottom>
                    <DelayLink
                      to="/iniciativas/analise-de-debentures-emitidas-pela-icvm-476"
                      className="card card--small card--yellow"
                    >
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            Autorregulação das debêntures emitidas pela ICVM 476
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>

                  <Fade bottom>
                    <DelayLink
                      to="/iniciativa/balanco-das-orientacoes-e-penalidades-da-autorregulacao"
                      className="card card--small card--yellow"
                    >
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            Reforço das ações <br className="br_desk" />
                            de supervisão
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>

                <div className="col-3">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/atuacao-internacional" className="card card--small card--yellow">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            Ênfase à nossa <br className="br_desk" />
                            atuação Internacional
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                  <Fade bottom>
                    <DelayLink to="/iniciativa/certificacao-e-educacao" className="card card--small card--yellow">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            Recorde em certificações emitidas
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container container--large">
              <div className="row">
                <div className="col-3">
                  <Fade bottom>
                    <DelayLink
                      to="/iniciativas/crescimento-na-precificacao-de-ativos"
                      className="card card--small card--yellow"
                    >
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            Crescimento <br className="br_desk" />
                            na precificação de ativos{' '}
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>

                  <Fade bottom>
                    <DelayLink to="/iniciativa/lei-liberdade-economica" className="card card--small card--yellow">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            Atuação em favor da Lei <br className="br_desk" />
                            de Liberdade Econômica
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>

                <div className="col-3">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/cursos-educativos" className="card card--small card--yellow">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            Ampliação da <br className="br_desk" />
                            oferta de cursos
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                  <Fade bottom>
                    <DelayLink
                     
                      to="/iniciativa/mercado-de-capitais"
                      className="card card--small card--yellow"
                    >
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--small">
                            Fortalecimento da <br className="br_desk" />
                            participação no IMK
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>

                <div className="col-6">
                  <Fade bottom>
                    <DelayLink to="/iniciativa/data-fundos" className="card card--yellow card--anbima-data with-image">
                      <div className="card__content card__content--full card1">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--large title-card1">
                            Lançamento do ANBIMA <br className="br_desk" />
                            Data Fundos
                          </h2>
                          <img src={images.para_o_mercado.grafico_fundos} className="grafico_fundos" />
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>

            <div className="container container--large">
              <div className="row">
                <div className="col-6">
                  <Fade bottom>
                    <DelayLink to="/iniciativas/nova-governanca-de-representacao" className="card card--yellow with-image">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--large">
                            Redesenho
                            <br />
                            <small className="small">da Representação Institucional</small>
                          </h2>
                          <img src={images.para_o_mercado.grafico_imk} className="grafico_imk" />
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>

                <div className="col-6">
                  <div className="row">
                    <div className="col-6">
                      <Fade bottom>
                        <DelayLink
                          to="/iniciativas/novo-sistema-de-protocolo-online-de-ofertas-publicas"
                          className="card card--small card--yellow"
                        >
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <h2 className="title title--gray title--small">
                                Lançamento do protocolo online de ofertas públicas
                              </h2>
                            </div>
                          </div>
                        </DelayLink>
                      </Fade>

                      <Fade bottom>
                        <DelayLink
                          to="/iniciativa/pesquisa-raio-x-do-investidor-brasileiro"
                          className="card card--small card--yellow"
                        >
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <h2 className="title title--gray title--small">
                              Divulgação da Pesquisa Raio X do Investidor Brasileiro (2ª edição)
                              </h2>
                            </div>
                          </div>
                        </DelayLink>
                      </Fade>
                    </div>

                    <div className="col-6">
                      <Fade bottom>
                        <DelayLink to="/iniciativa/selic-40-anos" className="card card--small card--yellow">
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <h2 className="title title--gray title--small">
                                Comemoração dos 40  <br className="br_desk" />
                                anos do Selic
                              </h2>
                            </div>
                          </div>
                        </DelayLink>
                      </Fade>

                      <Fade bottom>
                        <DelayLink
                          to="/iniciativas/visitas-educativas-a-gestores-de-patrimonio"
                          className="card card--small card--yellow"
                        >
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <h2 className="title title--gray title--small">
                                Acompanhamento aos gestores de patrimônio
                              </h2>
                            </div>
                          </div>
                        </DelayLink>
                      </Fade>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <Fade bottom>
                        <DelayLink
                          to="/iniciativa/supervisao-da-precificacao-de-ativos"
                          className="card card--small card--yellow with-image"
                        >
                          <div className="card__content card__content--full">
                            <div className="card__content__header card__content__header--no-border">
                              <h2 className="title title--gray title--small">
                                Supervisão da precificação de ativos <br className="br_desk" />e da distribuição de
                                cotas de fundos
                              </h2>
                              <img src={images.para_o_mercado.grafico_ativos} className="grafico_ativos" />
                            </div>
                          </div>
                        </DelayLink>
                      </Fade>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <DelayLink
                      to="/estrategias/dentro-de-casa"
                      className="card card--light-blue card--acoes-dentro-de-casa"
                    >
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h2 className="title title--gray title--large title--center">
                            Confira nossas ações <span className="light-blue">dentro de casa</span>
                          </h2>
                        </div>
                      </div>
                    </DelayLink>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="para-o-mercado-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-8 col--text">
                            <h4>Veja os eventos de 2019</h4>
                            <DelayLink
                              to="/eventos"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                          <div className="col col-4 col--image">
                            <img
                              src={images.nosso_ano.pessoa_destaque}
                              className="pessoa_destaque pessoa_destaque--1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { ParaOMercado };
